<template>
  <div class="columns is-multiline">
    <div
      v-for="aContact in contacts"
      :key="aContact.firstName+Math.ceil(Math.random()*100)"
      class="column is-half"
    >
      <address-card
        :contact="aContact"
      />
    </div>
  </div>
</template>

<script>
import AddressCard from './AddressCard'
import { mapState } from 'vuex'

export default {

  name: 'DomainContacts',
  components: {
    AddressCard
  },
  computed: {
    ...mapState('domainService', {
      contacts: state => state.contacts
    })
  }
}
</script>
